// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "clients" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "title": "Mes Clients",
      "subtitle": "{count} client(s) · Vue 360 par client avec produits, cours et consultations attachés.",
      "search": "Rechercher par nom ou email…",
      "empty": "Aucun client. Les contacts entrants depuis le formulaire public apparaîtront ici.",
      "noMatch": "Aucun client ne correspond.",
      "back": "Retour à la liste",
      "attached.title": "Items attachés",
      "attached.subtitle": "Reliez ce client à ses produits, cours, consultations.",
      "attached.empty": "Aucun item attaché. Cliquez sur un bouton ci-dessus pour relier ce client à un cours, produit ou consultation.",
      "attach.product": "Produit",
      "attach.course": "Cours",
      "attach.video_room": "Téléconsultation",
      "attach.modal.title": "Attacher un",
      "attach.modal.search": "Rechercher…",
      "attach.modal.empty": "Aucun élément disponible.",
      "notes.title": "Notes praticien",
      "notes.placeholder": "Ajouter une note (consultation, observation, suivi…)",
      "notes.add": "Ajouter",
      "notes.empty": "Aucune note pour le moment.",
      "notes.modified": "modifiée",
      "notes.confirmDelete": "Supprimer cette note ?",
      "docs.title": "Documents",
      "docs.upload": "Téléverser",
      "docs.empty": "Aucun document. Cliquez sur \"Téléverser\" pour ajouter une fiche, un bilan, une ordonnance…",
      "docs.confirmDelete": "Supprimer ce document ?",
      "toast.loadError": "Erreur de chargement",
      "toast.error": "Erreur",
      "toast.attached": "Attaché : {label}",
      "toast.confirmDetach": "Détacher cet élément ?",
      "toast.noteAdded": "Note ajoutée",
      "toast.docAttached": "Document attaché",
      "toast.uploadError": "Erreur upload",
      "action.download": "Télécharger"
  },
  "en": {
      "title": "My Clients",
      "subtitle": "{count} client(s) · 360° view per client with attached products, courses and consultations.",
      "search": "Search by name or email…",
      "empty": "No clients yet. Contacts from the public form will appear here.",
      "noMatch": "No client matches.",
      "back": "Back to list",
      "attached.title": "Attached items",
      "attached.subtitle": "Link this client to products, courses, consultations.",
      "attached.empty": "No items attached yet. Click a button above to link this client to a course, product or consultation.",
      "attach.product": "Product",
      "attach.course": "Course",
      "attach.video_room": "Telehealth",
      "attach.modal.title": "Attach a",
      "attach.modal.search": "Search…",
      "attach.modal.empty": "No items available.",
      "notes.title": "Practitioner notes",
      "notes.placeholder": "Add a note (consultation, observation, follow-up…)",
      "notes.add": "Add",
      "notes.empty": "No notes yet.",
      "notes.modified": "edited",
      "notes.confirmDelete": "Delete this note?",
      "docs.title": "Documents",
      "docs.upload": "Upload",
      "docs.empty": "No documents. Click \"Upload\" to attach a record, report, prescription…",
      "docs.confirmDelete": "Delete this document?",
      "toast.loadError": "Loading error",
      "toast.error": "Error",
      "toast.attached": "Attached: {label}",
      "toast.confirmDetach": "Detach this item?",
      "toast.noteAdded": "Note added",
      "toast.docAttached": "Document attached",
      "toast.uploadError": "Upload error",
      "action.download": "Download"
  },
  "es": {
      "title": "Mis Clientes",
      "subtitle": "{count} cliente(s) · Vista 360° por cliente con productos, cursos y consultas adjuntas.",
      "search": "Buscar por nombre o correo…",
      "empty": "Aún no hay clientes. Los contactos del formulario público aparecerán aquí.",
      "noMatch": "Ningún cliente coincide.",
      "back": "Volver a la lista",
      "attached.title": "Elementos adjuntos",
      "attached.subtitle": "Vincule este cliente con productos, cursos, consultas.",
      "attached.empty": "Aún no hay elementos adjuntos. Haga clic en un botón para vincular.",
      "attach.product": "Producto",
      "attach.course": "Curso",
      "attach.video_room": "Telesalud",
      "attach.modal.title": "Adjuntar un",
      "attach.modal.search": "Buscar…",
      "attach.modal.empty": "No hay elementos disponibles.",
      "notes.title": "Notas del profesional",
      "notes.placeholder": "Añadir una nota (consulta, observación, seguimiento…)",
      "notes.add": "Añadir",
      "notes.empty": "Aún no hay notas.",
      "notes.modified": "editada",
      "notes.confirmDelete": "¿Eliminar esta nota?",
      "docs.title": "Documentos",
      "docs.upload": "Subir",
      "docs.empty": "Sin documentos. Haga clic en \"Subir\".",
      "docs.confirmDelete": "¿Eliminar este documento?",
      "toast.loadError": "Error de carga",
      "toast.error": "Error",
      "toast.attached": "Adjuntado: {label}",
      "toast.confirmDetach": "¿Desadjuntar este elemento?",
      "toast.noteAdded": "Nota añadida",
      "toast.docAttached": "Documento adjuntado",
      "toast.uploadError": "Error de subida",
      "action.download": "Descargar"
  },
};
